import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch, RootStateOrAny } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Stack,
    PrimaryButton,
    ActionButton,
    IIconProps,
} from '@fluentui/react';
import { appStyles, logger } from '../../helpers';
import { isLocalFile, UploadFile } from '../../model';
import { appConstants } from '../../store/actions/app/actionTypes';
import { default as WizardOption } from './option';
import { File } from '../common';

type Props = {
    wizardPos: number;
    onEdit: (wizardPos: number) => void;
    onDestination: () => void;
    hideDestinationFolder?: boolean;
};

const WizardFiles = (props: Props) => {
    const uiState = useSelector((state: RootStateOrAny) => state.uiReducer);
    const appState = useSelector((state: RootStateOrAny) => state.appReducer);
    const dispatch = useDispatch();
    const removeButtonStyles = appStyles.actionButtonRemove;

    const [showDestFolder, setShowDestFolder] = useState(false);

    const deleteFile: IIconProps = {
        iconName: 'ChromeClose',
    };
    const _expand: IIconProps = {
        iconName: 'ChevronDownSmall',
    };
    const _collapse: IIconProps = {
        iconName: 'ChevronUpSmall',
    };

    useEffect(() => {
        if (props.hideDestinationFolder) {
            return;
        }

        setShowDestFolder(appState.filesToUpload.some(isLocalFile));
    }, [appState.filesToUpload, props.hideDestinationFolder]);

    const removeFile = (file: UploadFile, index: number) => {
        logger.info('action removeFile', 'Files');
        const newFilesList = [...appState.filesToUpload];
        newFilesList.splice(index, 1);
        dispatch({
            type: appConstants.APP_FILES_TO_UPLOAD,
            payload: { filesToUpload: newFilesList, removed: true },
        });
    };

    const renderFiles = () => {
        return (
            <Stack>
                {appState.filesToUpload.length > 0 ? (
                    appState.filesToUpload.map(
                        (item: UploadFile, index: number) => {
                            return (
                                <Stack
                                    key={index}
                                    horizontal
                                    verticalAlign="center"
                                    horizontalAlign="space-between"
                                    style={{ marginTop: 10 }}
                                >
                                    <File
                                        item={item}
                                        destinationFolder={
                                            appState.destinationFolder
                                        }
                                    ></File>
                                    <ActionButton
                                        iconProps={deleteFile}
                                        styles={removeButtonStyles}
                                        onClick={() => removeFile(item, index)}
                                    />
                                </Stack>
                            );
                        },
                    )
                ) : (
                    <></>
                )}
            </Stack>
        );
    };

    const onEdit = () => {
        props.onEdit(props.wizardPos);
    };

    return (
        <Stack>
            <Stack className={appStyles.globalStyles.sectionLayoutBorder}>
                <Stack
                    horizontal
                    verticalAlign="center"
                    horizontalAlign="space-between"
                >
                    <WizardOption
                        value={
                            appState.filesToUpload.length === 0
                                ? ''
                                : uiState
                                      .translate('sharefiles_filescount')
                                      .replace(
                                          '{0}',
                                          appState.filesToUpload.length,
                                      )
                        }
                        notSelectedText={uiState
                            .translate('sharefiles_filescount')
                            .replace('{0}', 0)}
                        displayIcon={true}
                    />
                    {props.wizardPos >= 0 ? (
                        <ActionButton
                            styles={appStyles.actionButtonEdit}
                            text={uiState.translate('button_edit')}
                            onClick={onEdit}
                        />
                    ) : (
                        <></>
                    )}
                </Stack>
                {renderFiles()}
                {showDestFolder ? (
                    <Stack horizontalAlign="end" style={{ marginTop: 10 }}>
                        <PrimaryButton
                            styles={appStyles.primaryButtonReverse}
                            text={uiState.translate('button_destinationfolder')}
                            onClick={() => {
                                if (
                                    props.onDestination !== null &&
                                    props.onDestination !== undefined
                                )
                                    props.onDestination();
                            }}
                        />
                    </Stack>
                ) : (
                    <></>
                )}
            </Stack>
        </Stack>
    );
};

export default WizardFiles;

WizardFiles.propTypes = {
    wizardPos: PropTypes.number,
    onEdit: PropTypes.func,
    onDestination: PropTypes.func,
};
